import { render } from "./propertiesNumber.vue?vue&type=template&id=48f4076e"
import script from "./propertiesNumber.vue?vue&type=script&lang=js"
export * from "./propertiesNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__